module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sellerPickerHolder"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.options,
      "allowEmpty": false,
      "multiple": false,
      "group-label": "false",
      "showLabels": false,
      "placeholder": "Select",
      "track-by": "id",
      "label": "name"
    },
    on: {
      "input": _vm.update
    },
    model: {
      value: (_vm.selectedSeller),
      callback: function($$v) {
        _vm.selectedSeller = $$v
      },
      expression: "selectedSeller"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v("No results.")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dec76728"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/TeamMemberPicker.vue
// module id = 1805
// module chunks = 0